<template>
  <v-card
    color="grey lighten-4"
    light
  >
    <v-card-text>
      <content-multi-section
        :options="options"
        :active="active"
        :on-change-section="changeSection"
      >
        <v-timeline
          dense
        >
          <v-timeline-item
            v-for="(item, i) in orderedItems"
            :key="i"
            :icon="item.icon || ''"
            :class="{transparent: item.transparent}"
            large
          >
            <template
              v-if="item.iconImage"
              v-slot:icon
            >
              <v-avatar>
                <img
                  :src="publicPath(item.iconImage)"
                >
              </v-avatar>
            </template>
            <template v-slot:opposite />
            <v-layout>
              <v-flex
                v-if="$vuetify.breakpoint.smAndUp"
                md1
                sm2
                align-self-center
              >
                <span>{{ item.year }}</span>
              </v-flex>
              <v-flex
                md11
                sm10
                xs12
              >
                <v-card class="elevation-1">
                  <v-card-title class="pb-0">
                    <div>
                      <p v-if="$vuetify.breakpoint.xsOnly">
                        {{ item.year }}
                      </p>
                      <h3>{{ item.title }}</h3>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout wrap>
                      <v-flex
                        :md7="!!item.image"
                        :md12="!item.image"
                        xs12
                      >
                        <div class="mr-1">
                          <span
                            v-if="item.text"
                            class="pre"
                          >{{ item.text }}</span>
                          <!-- eslint-disable vue/no-v-html -->
                          <div
                            v-else-if="item.html"
                            v-html="item.html"
                          />
                        <!-- eslint-enable vue/no-v-html -->
                        </div>
                      </v-flex>
                      <v-flex
                        v-if="item.image"
                        md5
                        xs12
                      >
                        <div
                          class="mt-2"
                        >
                          <v-carousel
                            v-if="Array.isArray(item.image)"
                            :show-arrows="false"
                            :height="325"
                          >
                            <v-carousel-item
                              v-for="(citem,ci) in item.image"
                              :key="ci"
                              :src="publicPath(citem)"
                            />
                          </v-carousel>
                          <v-img
                            v-else
                            :max-height="item.imageHeight ? item.imageHeight : ''"
                            :src="publicPath(item.image)"
                          />
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </content-multi-section>
    </v-card-text>
  </v-card>
</template>

<script>
import ContentMultiSection from '@/views/dark-template/content/MultiSection'
export default {
  name      : 'Timeline',
  components: { ContentMultiSection },
  data      : () => ({
    gaming: true,
    items : [
      {
        gaming     : true,
        transparent: false,
        year       : '2017',
        title      : 'Start Event Horizon School',
        html       : 'Join on the academy of Event Horizon School and learing all the functionality to develop a game',
        imageHeight: 200,
        iconImage  : 'img/timeline/tl-event_horizon_school.png',
      },
      {
        gaming     : true,
        year       : '2018',
        transparent: false,
        title      : 'Audio Programmer',
        html       : `
                <p> Start working for Event horizon Studio</p>
                <p>
                    I have work on the project TITANS: Dawn of Tribes
                </p>
                <p>
                    I have accomplished the following tasks:
                    <ul>
                        <li>
                            Audio integration with FMOD 
                        </li>
                        <li>
                            Made the Nintendo Switch Porting.
                        </li>
                        <li>
                            Bug fixing, and refatoring...
                        </li>
                    </ul>
              </p>
        `,
        image      : 'img/timeline/tl-Titans.jpg',
        imageHeight: 200,
        iconImage  : 'img/timeline/tl-event_horizon_studios.jpg',
      },
      {
        gaming     : true,
        year       : '2018',
        transparent: false,
        title      : 'GlobalGameJam 2018',
        html       : `
            <p>
              "A shooter never changes, this one does."
              <br>
              Developed in 48 hours, <a href="https://globalgamejam.org/2018/games/hijacker" target="_blank" class="arrow-link">Hijacker</a>
              is an FPS-vania wanna be, use your incredible power to control enemies and steal the data to
              learn new abilities;
              remember data is power!<br>
              AI, FPS controller, UI by me
            </p>
        `,
        image      : 'img/timeline/tl-hijacker.png',
        imageHeight: 200,
        iconImage  : 'img/timeline/tl-GGJ.jpg',
      },
      {
        gaming     : true,
        year       : '2019',
        transparent: false,
        title      : 'GlobalGameJam 2019',
        html       : `
            <p>
              Developed in 48 hours, <a href="https://globalgamejam.org/2019/games/drunktard" target="_blank" class="arrow-link">DrankTard</a>
              is a drank simulator where you need to do some simple tasks... <br>
              Code by me.
            </p>
        `,
        image      : 'img/timeline/tl-GGJ_2019.jpg',
        imageHeight: 200,
        iconImage  : 'img/timeline/tl-GGJ.jpg',
      },
      {
        gaming     : true,
        year       : '2019',
        transparent: false,
        title      : 'Ludum Dare 43',
        html       : `
            <p>
              Developed in 48 hours, <a href="https://cyberpan.itch.io/not-me" target="_blank" class="arrow-link">Notme!</a>
              It's like Tinder but you have to BUST the murderer.<br>
              UI and Audio integration by me
            </p>
        `,
        image      : 'img/timeline/tl-not_me.png',
        imageHeight: 200,
        iconImage  : 'img/timeline/tl-LD.png',
      },
      {
        gaming     : true,
        year       : '2020',
        transparent: false,
        title      : 'Cyberpank game jam 2019',
        html       : `
            <p>
              Developed in 48 hours, <a class="underline-link" href="https://nicholasfalcone.itch.io/deliverpunk " target="_blank">Deliverpunk</a>
              is a 3D endless game. You have to avoid obstacles and gain power-ups to reach
              the
              best
              score!<br>
              UI and Gameplay by me.
            </p>
        `,
        image      : 'img/timeline/tl-deliverpunk.png',
        imageHeight: 200,
        iconImage  : 'img/timeline/tl-cgj.png',
      },
      {
        gaming     : true,
        year       : '2020',
        transparent: false,
        title      : 'Global Game Jam',
        html       : `
            <p>
              Developed in 48 hours, <a class="underline-link" href="https://globalgamejam.org/2020/games/jack-killer-2 " target="_blank">Jack is the killer</a> is a
              detective game where you need to solve a murder mystery that tells you who the killer is...but you still
              have got to figure it out. And you only
              have sounds
              and still frames to guide you.<br>
              UI and Gameplay by me.
            </p>
        `,
        image      : 'img/timeline/tl-jack_is_the_killer.jpg',
        imageHeight: 200,
        iconImage  : 'img/timeline/tl-bf.png',
      },
      {
        gaming     : true,
        year       : '2020',
        transparent: false,
        title      : 'Ludum Date 46',
        html       : `
            <p>
              Developed in 48 hours,
              <a class="underline-link" href=" https://born-frustrated.itch.io/the-blackness-from-the-stars" target="_blank">The blankness from the stars</a>
              is a game where you need to explore and fetch the embers around the island, then feed them to the furnace
              inside the house.
              That will keep the light alive. 'Cause light is your only hope.<br>
              UI and Gameplay by me.
            </p>
        `,
        image      : 'img/timeline/tl-blankness_from_the_stars.gif',
        imageHeight: 200,
        iconImage  : 'img/timeline/tl-bf.png',
      },
      {
        gaming     : true,
        year       : '2020',
        transparent: false,
        title      : 'Porting Specialist & Network Programmer',
        html       : `
               <p>
                    Start working for 34BigThings for the relase of "90's Super GP"
                </p>
                <p>
                    I have accomplished the following tasks:
                </p>
                    <ul>
                        <li>
                            Develop the networking system.
                        </li>
                        <li>
                            Made the Nintendo Switch Porting.
                        </li>
                        <li>
                            Bug fixing, and refatoring...
                        </li>
                    </ul>
                </p>
        `,
        image      : 'img/timeline/tl-90_super_gp.jpg',
        imageHeight: 200,
        iconImage  : 'img/timeline/tl-34_big_things.png',
      },
      {
        gaming     : true,
        year       : '2022',
        transparent: false,
        title      : 'Gomorrah - 34BigThings',
        html       : `
               <p>
                    Working as Freelancer for 34BigThings on this title   
                </p>
                <p>
                    I have accomplished the following tasks:
                </p>
                    <ul>
                        <li>
                            Project Optimization
                        </li>
                        <li>
                            Realization of the porting on PC.
                        </li>
                        <li>
                            Release on the following platform: Steam, Apple Store, Play Store.
                        </li>
                        <li>
                            Bug fixing, and refatoring...
                        </li>
                    </ul>
                </p>
        `,
        image      : 'img/timeline/tl-gomorrah.jpg',
        imageHeight: 200,
        iconImage  : 'img/timeline/tl-34_big_things.png',
      },
      {
        gaming     : true,
        year       : '2022 - now',
        transparent: false,
        title      : 'On Your Tail - Memorable Game',
        html       : `
               <p>
                    I'm currently working as Generalist Programmer for Memorable Game
              </p>
              <ul>
                  <li>
                      Create sturcture for CI-CD.
                  </li>
                  <li>
                      Developed Game Mechanics.
                  </li>
                  <li>
                      Game Optimization and Bug Fixs
                  </li>
                  <li>
                      Developed Shaders!
                  </li>
              </ul>
        `,
        image      : 'img/timeline/OYT.jpg',
        imageHeight: 200,
        iconImage  : 'img/timeline/memorablegames_logo.jpg',
      },
      //* * Web dev jobs and experiences */
      {
        gaming     : false,
        year       : '2020 - 2021',
        transparent: false,
        title      : 'Full stack developer',
        html       :
        `
          <p> 
            We have developed a Web Application with you can shop and view some 3D block of marble.
          </p>
          <p>
            This application use the following technologies: Angular, NodeJs, MongoDB, Unity.
            I worked principally on the backend side, developing the API and server feature.
            I'm also managing the webserver related tasks (security, server configuration, CI.CD, backup system, others...).
          </p>
        `,
        image      : 'img/timeline/tl-marmo3d.jpg',
        imageHeight: 200,
        iconImage  : 'img/timeline/tl-objvision.png',
      },
      {
        gaming     : false,
        year       : '2020 - 2021',
        transparent: false,
        title      : 'Backend Developer',
        html       :
        `
          I worked as a consultant for the following company "Stem5", developing some backend feature, using Python with Django.
        `,
        image      : 'img/timeline/tl-2b_voip.png',
        imageHeight: 200,
        iconImage  : 'img/timeline/tl-stem5.png',
      },
      {
        gaming     : false,
        year       : '2021 - 2022',
        transparent: false,
        title      : 'Full stack developer - MG3',
        html       : `
            <p>
              I have worked as a FullStack Developer on some web applications.
              I principally use the following technologies: Angular, Node and .NET
            </p>
        `,
        image      : 'img/timeline/image-asset.jpeg',
        imageHeight: 200,
        iconImage  : 'img/timeline/logo_mg3_sito.svg',
      },
    ],
    options: ['Game Develop', 'Web Develop'],
    active : 'Game Develop',
  }),
  computed: {
    orderedItems () {
      const items = [...this.items].reverse()
      return items.filter((x) => x.gaming === this.gaming)
    },
  },
  methods: {
    changeSection (value) {
      this.gaming = value.toString().includes('Game')
    },
  },
}
</script>

<style scoped>
.title {
  border-bottom: 2px #bfbfbf solid;
  line-height: 1.5 !important;
}
.pre {
  white-space: pre;
}
.transparent{
  opacity: 0.6;
}
</style>
